import { __decorate, __param } from 'tslib';
import { Injector, Inject, INJECTOR, Component, ChangeDetectionStrategy, ViewEncapsulation, NgModule } from '@angular/core';
import { TUI_PARENT_ANIMATION } from '@taiga-ui/cdk/constants';
import { TUI_ALERTS } from '@taiga-ui/cdk/tokens';
import { POLYMORPHEUS_CONTEXT } from '@tinkoff/ng-polymorpheus';
import { CommonModule } from '@angular/common';
import { TuiMapperPipeModule } from '@taiga-ui/cdk/pipes';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@taiga-ui/cdk/pipes';

function TuiAlertHostComponent_div_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0, 3);
    ɵngcc0.ɵɵpipe(1, "tuiMapper");
} if (rf & 2) {
    const item_r3 = ctx.$implicit;
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngComponentOutlet", item_r3.component.component)("ngComponentOutletInjector", ɵngcc0.ɵɵpipeBind2(1, 2, item_r3, ctx_r2.mapper));
} }
function TuiAlertHostComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵtemplate(1, TuiAlertHostComponent_div_0_ng_container_1_Template, 2, 5, "ng-container", 2);
    ɵngcc0.ɵɵpipe(2, "async");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const alert$_r1 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("@tuiParentAnimation", undefined);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ɵngcc0.ɵɵpipeBind1(2, 2, alert$_r1));
} }
let TuiAlertHostComponent = class TuiAlertHostComponent {
    constructor(alerts, injector) {
        this.alerts = alerts;
        this.injector = injector;
        this.mapper = useValue => Injector.create({
            providers: [
                {
                    provide: POLYMORPHEUS_CONTEXT,
                    useValue,
                },
            ],
            parent: this.injector,
        });
    }
};
TuiAlertHostComponent.ɵfac = function TuiAlertHostComponent_Factory(t) { return new (t || TuiAlertHostComponent)(ɵngcc0.ɵɵdirectiveInject(TUI_ALERTS), ɵngcc0.ɵɵdirectiveInject(INJECTOR)); };
TuiAlertHostComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TuiAlertHostComponent, selectors: [["tui-alert-host"]], decls: 1, vars: 1, consts: [["class", "t-notifications-wrapper", 4, "ngFor", "ngForOf"], [1, "t-notifications-wrapper"], [3, "ngComponentOutlet", "ngComponentOutletInjector", 4, "ngFor", "ngForOf"], [3, "ngComponentOutlet", "ngComponentOutletInjector"]], template: function TuiAlertHostComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, TuiAlertHostComponent_div_0_Template, 3, 4, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngForOf", ctx.alerts);
    } }, directives: [ɵngcc1.NgForOf, ɵngcc1.NgComponentOutlet], pipes: [ɵngcc1.AsyncPipe, ɵngcc2.TuiMapperPipe], styles: ["tui-alert-host>.t-notifications-wrapper{position:fixed;top:0;left:0;display:flex;width:100%;height:100%;flex-direction:column;pointer-events:none}tui-alert-host>.t-notifications-wrapper>*{pointer-events:auto}"], encapsulation: 2, data: { animation: [TUI_PARENT_ANIMATION] }, changeDetection: 0 });
TuiAlertHostComponent.ctorParameters = () => [
    { type: Array, decorators: [{ type: Inject, args: [TUI_ALERTS,] }] },
    { type: Injector, decorators: [{ type: Inject, args: [INJECTOR,] }] }
];
TuiAlertHostComponent = __decorate([ __param(0, Inject(TUI_ALERTS)),
    __param(1, Inject(INJECTOR))
], TuiAlertHostComponent);

let TuiAlertHostModule = class TuiAlertHostModule {
};
TuiAlertHostModule.ɵfac = function TuiAlertHostModule_Factory(t) { return new (t || TuiAlertHostModule)(); };
TuiAlertHostModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: TuiAlertHostModule });
TuiAlertHostModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, TuiMapperPipeModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiAlertHostComponent, [{
        type: Component,
        args: [{
                selector: 'tui-alert-host',
                template: "<div\n    *ngFor=\"let alert$ of alerts\"\n    class=\"t-notifications-wrapper\"\n    @tuiParentAnimation\n>\n    <ng-container\n        *ngFor=\"let item of alert$ | async\"\n        [ngComponentOutlet]=\"item.component.component\"\n        [ngComponentOutletInjector]=\"item | tuiMapper : mapper\"\n    ></ng-container>\n</div>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                animations: [TUI_PARENT_ANIMATION],
                encapsulation: ViewEncapsulation.None,
                styles: ["tui-alert-host>.t-notifications-wrapper{position:fixed;top:0;left:0;display:flex;width:100%;height:100%;flex-direction:column;pointer-events:none}tui-alert-host>.t-notifications-wrapper>*{pointer-events:auto}"]
            }]
    }], function () { return [{ type: Array, decorators: [{
                type: Inject,
                args: [TUI_ALERTS]
            }] }, { type: ɵngcc0.Injector, decorators: [{
                type: Inject,
                args: [INJECTOR]
            }] }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiAlertHostModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, TuiMapperPipeModule],
                declarations: [TuiAlertHostComponent],
                exports: [TuiAlertHostComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TuiAlertHostModule, { declarations: function () { return [TuiAlertHostComponent]; }, imports: function () { return [CommonModule, TuiMapperPipeModule]; }, exports: function () { return [TuiAlertHostComponent]; } }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { TuiAlertHostComponent, TuiAlertHostModule };

